window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateFeaturesSection = function(variant){
    let pdpFeaturesSections = document.querySelectorAll(".pdp-features");
    pdpFeaturesSections.forEach((pdpFeaturesSection) => {
        let allDefaultImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media.pdp-features__slide-media--default`);
        let allDefaultSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle.pdp-features__slide-subtitle--default`);
        let allDefaultTitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-title.pdp-features__slide-title--default`);

        allDefaultImages.forEach((defaultImage) => {
            defaultImage.style.display = "block"
          });
    
          allDefaultSubtitles.forEach((defaultSubtitle) => {
            defaultSubtitle.style.display = "block"
          })

          allDefaultTitles.forEach((defaultTitle) => {
            defaultTitle.style.display = "block"
          })
    
    if(variant){
        let altVariantImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media[data-variant-id="${variant.id}"]`);
        let allNonDefaultImages = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-media:not(.pdp-features__slide-media--default)`);
        
        let altVariantSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle[data-variant-id="${variant.id}"]`);
        let allNonDefaultSubtitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-subtitle:not(.pdp-features__slide-subtitle--default)`);
        
        let altVariantTitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-title[data-variant-id="${variant.id}"]`);
        let allNonDefaultTitles = pdpFeaturesSection.querySelectorAll(`.pdp-features__slide-title:not(.pdp-features__slide-title--default)`);
     
        if(allNonDefaultImages.length > 0 ){
          allNonDefaultImages.forEach(( nonDefaultImage) => {
            nonDefaultImage.style.display = "none"
          })
        }
  
        if(allNonDefaultSubtitles.length > 0 ){
          allNonDefaultSubtitles.forEach(( nonDefaultSubtitle) => {
            nonDefaultSubtitle.style.display = "none"
          })
        }

        if(allNonDefaultTitles.length > 0 ){
          allNonDefaultTitles.forEach(( nonDefaultTitle) => {
            nonDefaultTitle.style.display = "none"
          })
        }
        
        if(altVariantImages.length > 0){
          altVariantImages.forEach((altVariantImage) => {
            altVariantImage.parentElement.querySelectorAll('.pdp-features__slide-media').forEach((slideMedia) => {
              slideMedia.style.display = 'none';
            })
            altVariantImage.style.display = "block";
          })
        } 

        if(altVariantSubtitles.length > 0){
          altVariantSubtitles.forEach((altVariantSubtitle) => {
            altVariantSubtitle.parentElement.querySelectorAll('.pdp-features__slide-subtitle').forEach((slideSubtitle) => {
              slideSubtitle.style.display = 'none';
            })
            altVariantSubtitle.style.display = "block";
          })
        } 

        if(altVariantTitles.length > 0){
          altVariantTitles.forEach((altVariantTitle) => {
            altVariantTitle.parentElement.querySelectorAll('.pdp-features__slide-title').forEach((slideTitle) => {
              slideTitle.style.display = 'none';
            })
            altVariantTitle.style.display = "block";
          })
        }
    }

    })

    // A variant can swap which clip a slide shows; load the shown ones, drop the hidden ones.
    if(window.Branch.product.syncPDPFeaturesVideos){
      window.Branch.product.syncPDPFeaturesVideos();
    }
}

$(function(){
    // Video memory. A video element keeps its download and decoder after pause(), and so does every
    // product page Safari holds in its back/forward cache, all inside the tab's memory limit.
    // Sources sit in data-src (pdp_features_snippet.liquid) until the slider is within a screen
    // of the viewport, and are dropped again when it is further away or the page is cached.
    function attachVideo(video){
        if(video.getAttribute('data-video-attached') === 'true'){
            return;
        }
        video.querySelectorAll('source[data-src]').forEach(function(source){
            source.setAttribute('src', source.getAttribute('data-src'));
        });
        video.setAttribute('data-video-attached', 'true');
        video.preload = 'auto';
        video.load();
    }

    function releaseVideo(video){
        if(video.getAttribute('data-video-attached') !== 'true'){
            return;
        }
        video.pause();
        video.querySelectorAll('source[src]').forEach(function(source){
            source.removeAttribute('src');
        });
        video.removeAttribute('data-video-attached');
        video.removeAttribute('data-video-loaded');
        video.preload = 'none';
        video.load();
    }

    function playVideo(video){
        if(!video || video.getAttribute('data-video-attached') !== 'true'){
            return;
        }
        var playing = video.play();
        if(playing && playing.catch){
            playing.catch(function(){});
        }
    }

    // Tab filtering takes slides out of the DOM, so walk the full list kept at slider init.
    function sectionVideos(sliderContainer){
        var roots = sliderContainer._pdpAllSlides || [sliderContainer];
        var videos = [];
        roots.forEach(function(root){
            root.querySelectorAll('video').forEach(function(video){ videos.push(video); });
        });
        return videos;
    }

    function playActiveVideo(sliderContainer){
        var swiper = sliderContainer._pdpSwiper;
        if(!swiper || window.Branch.functions.isTouchDevice() != true){
            return;
        }
        var slide = swiper.slides[swiper.activeIndex];
        playVideo(slide && slide.querySelector('video'));
    }

    function syncSectionVideos(sliderContainer){
        var near = sliderContainer.getAttribute('data-videos-near') === 'true';
        sectionVideos(sliderContainer).forEach(function(video){
            if(near && sliderContainer.contains(video) && video.style.display !== 'none'){
                attachVideo(video);
            } else {
                releaseVideo(video);
            }
        });
        if(near){
            playActiveVideo(sliderContainer);
        }
    }

    window.Branch.product.syncPDPFeaturesVideos = function(){
        document.querySelectorAll('.pdp-features__slider-container').forEach(syncSectionVideos);
    };

    function observeSectionVideos(){
        var sliderContainers = document.querySelectorAll('.pdp-features__slider-container');
        if(typeof IntersectionObserver === 'undefined'){
            sliderContainers.forEach(function(sliderContainer){
                sliderContainer.setAttribute('data-videos-near', 'true');
                syncSectionVideos(sliderContainer);
            });
            return;
        }
        var observer = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
                entry.target.setAttribute('data-videos-near', entry.isIntersecting ? 'true' : 'false');
                syncSectionVideos(entry.target);
            });
        }, {rootMargin: '100% 0px'});
        sliderContainers.forEach(function(sliderContainer){ observer.observe(sliderContainer); });

        window.addEventListener('pagehide', function(event){
            if(!event.persisted) return;
            sliderContainers.forEach(function(sliderContainer){
                sliderContainer.setAttribute('data-videos-near', 'false');
                syncSectionVideos(sliderContainer);
            });
        });
        // Observing again reports the slider's current position, which reloads it if near.
        window.addEventListener('pageshow', function(event){
            if(!event.persisted) return;
            sliderContainers.forEach(function(sliderContainer){
                observer.unobserve(sliderContainer);
                observer.observe(sliderContainer);
            });
        });
    }

    function filterSlidesByTab(sliderContainer, tabLabel){
        var swiper = sliderContainer._pdpSwiper;
        var allSlides = sliderContainer._pdpAllSlides;
        if(!swiper || !allSlides) return;

        var hasTaggedSlides = allSlides.some(function(slide){ return slide.hasAttribute('data-tab'); });
        if(!hasTaggedSlides) return;

        var wrapper = sliderContainer.querySelector('.swiper-wrapper');
        if(!wrapper) return;

        var normalized = (tabLabel || '').replace(/\s+/g, ' ').trim().toLowerCase();

        allSlides.forEach(function(slide){
            if(slide.parentNode) slide.parentNode.removeChild(slide);
        });
        allSlides.forEach(function(slide){
            var slideTab = slide.getAttribute('data-tab');
            if(!slideTab || slideTab === normalized){
                wrapper.appendChild(slide);
            }
        });

        swiper.update();
        swiper.slideTo(0, 0);
        syncSectionVideos(sliderContainer);
    }

    if(!window.__pdpFeaturesTabSyncBound){
        window.__pdpFeaturesTabSyncBound = true;
        document.addEventListener('hype-chair-tab-change', function(e){
            var tabLabel = (e.detail && e.detail.tabLabel) || '';
            document.querySelectorAll('.pdp-features__slider-container').forEach(function(c){
                filterSlidesByTab(c, tabLabel);
            });
        });
    }

    const initPDPFeaturesSlider = function(event){
        if (typeof window.Swiper === 'undefined') {
            if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(function(){ initPDPFeaturesSlider(event); });
            }
            return;
        }
        let sliderContainers = document.querySelectorAll('.pdp-features__slider-container');

        sliderContainers.forEach((sliderContainer, index) => {
            let autoscroll = false;
            if(sliderContainer.getAttribute('data-enable-autoscroll') == "true"){
                let autoscrollInterval = parseInt(sliderContainer.getAttribute('data-autoscroll-interval')) * 1000;;
                autoscroll = {
                    delay: autoscrollInterval,
                    disableOnInteraction: true
                    }
            }

            let params = {};
            if(event == "gallery-open"){
                params = {
                    slidesPerView: 1,
                    zoom: true,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoscroll
                    }
            }
            if(event == "load"){
                let sliderElement = sliderContainer.querySelector('.pdp-features__slider');
                params = {
                    slidesPerView: 1.33333333333,
                    spaceBetween: 20,
                    freeMode: false,
                    autoplay: autoscroll,
                    navigation: {
                        nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                        prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 2.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                            }
                        },
                        1024: {
                            slidesPerView: 3.5,
                            spaceBetween: 40,
                            freeMode: false,
                            autoplay: autoscroll,
                            navigation: {
                                nextEl: sliderContainer.querySelector('.pdp-features__right-arrow.swiper-button-next'),
                                prevEl: sliderContainer.querySelector('.pdp-features__left-arrow.swiper-button-prev'),
                            }
                        }
                    },
                        on: {
                            init: function(){
                                if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                    if(window.Branch.functions.isTouchDevice() == true){
                                        playVideo(this.slides[this.activeIndex].querySelector('video'));
                                    }
                                }
                            },
                            activeIndexChange: function () {
                                if(window.Branch.functions.isTouchDevice() == true){
                                    this.slides.forEach((slide) => {
                                        if(slide.querySelector('video')){
                                            slide.querySelector('video').pause();
                                        }
                                        console.log('slide.classList', slide.classList.contains('swiper-slide-active'))
                                        // if(slide.classList.contains('swiper-slide-active')){
                                        //     slide.querySelector('video').play();
                                        // }
                                        
                                    })
                                    if(this && this.slides[this.activeIndex] && this.slides[this.activeIndex].querySelector('video')){
                                        playVideo(this.slides[this.activeIndex].querySelector('video'));
                                    }
                                }
                            }
                    }
                }
                var pdpFeaturesSwiper = new Swiper(sliderElement, params);

                sliderContainer._pdpSwiper = pdpFeaturesSwiper;
                sliderContainer._pdpAllSlides = Array.from(sliderElement.querySelectorAll('.swiper-slide'));

                var initialActiveBtn = document.querySelector('.hype-chair-tabs .hype-chair-tabs__button[data-active="true"]');
                if(initialActiveBtn){
                    filterSlidesByTab(sliderContainer, (initialActiveBtn.innerText || initialActiveBtn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase());
                }
            }
        })
    }


    const initHoverVideoPlay = function(video){
        video.addEventListener('mouseenter', function() {
            playVideo(video);
        });
        video.addEventListener('mouseleave', function() {
            video.pause();
        });    
    }

    const initVideos = function(){
        let videos = document.querySelectorAll('.pdp-features__slider-container video');
        videos.forEach((video) => {
            function addLoadedClass() {
                video.setAttribute('data-video-loaded', true);
            }
    
            if (video.readyState >= 2) {
                addLoadedClass();
            } else {
                video.addEventListener('loadeddata', addLoadedClass);
            }


            if(window.Branch.functions.isTouchDevice() == false){
                initHoverVideoPlay(video);
            }
        });
    }

    const initPDPFeatures = function(){
        initVideos();
        initPDPFeaturesSlider("load");
        observeSectionVideos();
    }
    
    window.addEventListener('load', function(){
        initPDPFeatures();
    });
});
